import React, { useContext } from 'react';
import { Link } from "react-router-dom";
import { GlobalContext } from '../../contexts/GlobalContext';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import PageTitle from '../../components/PageTitle/PageTitle';
import CardServices from '../../components/Cardservices/CardServices';
import Divider from '../../components/Divider/Divider';
import './Services.css'

const Services = () => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const data = require(`../../assets/languages/${language}/services.json`);
    const {
        breadcrumb,
        selectedPage,
        pageTitle,
        pageSubtitle,
        servicesItens,
        transportWhitBacIntro,
        transportWhitBacContent,
        serviceId,
        textLink,
        link
    } = data

    const TransportWhitBac = () => {
        return (
            <div className='about-transport-whit-bac-container mg-bot-100 card-services-simple'>
                <div className='content-card-services-simple' id={serviceId}>
                    <span className='text-title-secondary'>{transportWhitBacIntro}</span>
                    <span className='text-content-card-simple'>{transportWhitBacContent}<Link to={link} className='link-card'>{textLink}</Link></span>
                </div>
            </div>
        )
    }

    return (
        <>
            <Breadcrumb
                beforeRoutes={breadcrumb}
                selectedPage={selectedPage}
                ignoreMgBot={true}
            />
            <div className='main-container'>
                <section className="section-container">
                    <PageTitle title={pageTitle} subtitle={pageSubtitle} />
                    {servicesItens.map((d, i) => {
                        return (
                            <div key={i}>
                                <CardServices title={d.title} content={d.content} image={d.image} _id={d.serviceId} />
                                {i + 1 < servicesItens.length ? (
                                    <Divider margin='70px 0' />
                                ) : (
                                    <div className='mg-bot-0' />
                                )}
                            </div>
                        )
                    })}
                </section>
            </div>

            <div className='main-container'>
                <div className="section-container">
                <Divider width='100%' margin='70px 0 0 0'/>
                    {TransportWhitBac()}
                </div>
            </div>
        </>
    )
}
export default Services